import {isDefined} from '@acng/frontend-bounty/std/value.js';
import {OBJECT, guard} from '@acng/frontend-rubicon';

import {logger} from '../../Lib/Log/client.js';
import {IcebreakerResponse} from '../../Lib/Log/events/icebreakerResponse.js';
import {TIMESTAMP} from '../../core/model/time.js';
import {inject} from 'acng/core/service/ng.js';
import {post} from 'acng/core/service/backend.js';
import {t} from '../../locale/config/translate.js';

import {getRecentMessage} from './recent-message.js';
import {publishUserMessage} from './event-bus.js';

/**
 * It might be easier to use a `MessageDraft`.
 *
 * @see [MessageDraft](../model/message-composer.js)
 *
 * @param {HTMLElement} context
 * @param {import('../model/message').Message} message
 */
export const sendMessage = async (context, message) => {
  const {amateur} = message;
  const nickname = amateur.getNickname();

  const res = await post(
    'message/send',
    {
      body: message.body,
      recipient: amateur.id,
      price: inject('price').get(amateur),
      attachment_id: message.attachment?.id,
      icebreakerAnswer: await isIcebreakerAnswer(amateur),
    },
    context,
    /** @returns {Promise<{time: number}>} */
    async (error) => {
      if (error.code == -2) {
        error.message = await t('messenger.signupRequired', {nickname});
      } else if (error.code >= 4000 && error.code < 5000) {
        error.message = await t('messenger.paymentRequired', {nickname});
      }
      throw error;
    }
  );
  ASSERT: guard(res, OBJECT({time: TIMESTAMP}));

  message.timestamp_ms = res.time * 1000;
  publishUserMessage(message);
};

/**
 * @param {Amateur} amateur
 * @returns {Promise<boolean>}
 */
const isIcebreakerAnswer = async (amateur) => {
  const lastMessage = await getRecentMessage(amateur);

  if (lastMessage) {
    const {ibid} = lastMessage.payload;

    if (isDefined(ibid)) {
      logger.send(new IcebreakerResponse(lastMessage.body, ibid, amateur.id));

      return true;
    }
  }

  return false;
};
